import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',

      '& > $field + $field': {
        marginTop: theme.spacing(2),
      },
    },
    field: {},
  }),
  { name: 'FormProduct' }
);
